import picturefill from "picturefill";
picturefill();



// 実行
$(function () {
  new CleanovationApp();
});




////////////////////////////////////////////////////////////////////////////////////
// Cleanovation App
////////////////////////////////////////////////////////////////////////////////////

class CleanovationApp {

  constructor() {
    this.$win = $(window);
    this.$html = $('html');
    this.$body = $('body');
    this.spFlag = this.$win.width() < 769;


    // tabs
    this.tabsWrap = $(".js-tabs-wrap");
    this.tabs = this.tabsWrap.find(".js-tabs a");
    this.tabsContent = this.tabsWrap.find(".js-tabs-content");


    // kvPanelChange


    // smoothScroll
    this.time = 700;
    this.offsetY = this.spFlag ? 0 : $(".gb-common-2019_header").outerHeight(); // ヘッダー等の固定領域がある場合はその値
    this.hash = location.hash;


    // video



    // 実行
    this.loadingAnimation();
    this.tabsChange();
    this.kvPanelChange();
    this.modalVideo();
    // this.smoothScroll();
  }



  /*------------------------------------
  Loading Animation KV
  -------------------------------------*/
  loadingAnimation() {
    const self = this;

    // メインタイムラインを設定
    const master = new TimelineMax();

    // secen1
    // 背景表示
    function scene01() {
      const tl = new TimelineMax();

      // 背景表示
      tl.to('.kv__inner', 3, {
        opacity: 1,
        // ease: Power4.easeOut
      });

      return tl;
    }


    // secen2
    // テキスト表示
    function scene02() {
      const tl = new TimelineMax();


      // テキスト表示
      tl.to('.kv__title', 2.5, {
        opacity: 1,
        ease:Power1.easeOut
      });

      tl.to('.kv__text-wrap', 2.5, {
        opacity: 1,
        ease:Power1.easeOut
      },'-=2.5');

      // テキスト非表示
      tl.to('.kv__text-wrap', 1, {
        opacity: 0,
        ease:Power1.easeOut
      });

      if(!self.spFlag) {
        // pc
        tl.to('.kv__title', 1, {
          top: '2.9vw',
          ease:Power1.easeOut
        }, '-=1');
      } else {
        tl.to('.kv__title', 1, {
          top: '5.7vw',
          ease:Power1.easeOut
        }, '-=1');
      }

      tl.set('.kv__title', {
        className: "+=is-active"
      });

      tl.to('.kv__panel__wrap', 1, {
        opacity: 1,
        ease:Power1.easeOut
      }, '-=1');

      return tl;
    }


    // secen3
    // パネル表示
    function scene03() {
      const tl = new TimelineMax();

      if(!self.spFlag) {
        // pc

        tl.set('.circle',{
          'stroke-dasharray': '0 2386'
        })

        //  clean-synergy
        tl.to('.kv__panel__clean-synergy', 1,{
          opacity: 1,
          ease:Power1.easeOut
        });

        // tl.set('.circle01', {
        //   className: "+=circleAnime01"
        // });

        //  EWATER+ for WAND
        tl.to('.circle01', .6,{
          'stroke-dasharray': '185 2386',
          opacity: .6,
          ease:Power1.easeOut
        },'-=.8');


        // content
        tl.to('.kv__panel__ewater-wand', .6,{
          opacity: 1,
          ease:Power1.easeOut
        }, '-=.6');

// console.log('test')
        //  EWATER+ for BOWL
        // circle
        tl.to('.circle02', .6,{
          'stroke-dasharray': '315 2386',
          opacity: .6,
          ease:Power1.easeOut
        });
        // content
        tl.to('.kv__panel__ewater-bowl', .6,{
          opacity: 1,
          ease:Power1.easeOut
        }, '-=.6');


        // CEFIONTECT
        // circle
        tl.to('.circle03', .6,{
          'stroke-dasharray': '170 2386',
          opacity: .6,
          ease:Power1.easeOut
        });

        // content
        tl.to('.kv__panel__cefiontect', .6,{
          opacity: 1,
          ease:Power1.easeOut
        }, '-=.6');


        // TORNADO FLUSH
        // circle
        tl.to('.circle04', .6,{
          'stroke-dasharray': '91 2386',
          opacity: .6,
          ease:Power1.easeOut
        });

        // content
        tl.to('.kv__panel__tornado-flush', .6,{
          opacity: 1,
          ease:Power1.easeOut
        }, '-=.6');


        // PREMIST
        // circle
        tl.to('.circle05', .6,{
          'stroke-dasharray': '370 2386',
          opacity: .6,
          ease:Power1.easeOut
        });

        // content
        tl.to('.kv__panel__premist', .6,{
          opacity: 1,
          ease:Power1.easeOut
        }, '-=.3');

        tl.to('.circle06', .6,{
          'stroke-dasharray': '99 2386',
          opacity: .6,
          ease:Power1.easeOut
        });

      } else {

        // sp
        tl.staggerTo('.kv__panel', 1.5,{
          opacity: 1,
          ease:Power1.easeOut
        }, 0.2);

        // cir
        tl.add(TweenMax.to('.circle01', 1,{
          'stroke-dasharray': '185 2386',
          opacity: .6
        },'-=1.5'));

        tl.add(TweenMax.to('.circle02', .1,{
          'stroke-dasharray': '315 2386',
          opacity: .6
        }));

        // CEFIONTECT
        // circle
        tl.add(TweenMax.to('.circle03', .1,{
          'stroke-dasharray': '170 2386',
          opacity: .6
        }));

        tl.add(TweenMax.to('.circle04', .1,{
          'stroke-dasharray': '91 2386',
          opacity: .6
        }));

        tl.add(TweenMax.to('.circle05', .1,{
          'stroke-dasharray': '370 2386',
          opacity: .6
        }));

        tl.add(TweenMax.to('.circle06', .1,{
          'stroke-dasharray': '99 2386',
          opacity: .6
        }, '-=.8'));
      }

      tl.set('.kv', {
        className: "+=is-loaded"
      });

      return tl;
    }


    master.add(scene01(), 'scene01')
          .add(scene02(), 'scene02')
          .add(scene03(), 'scene03');


    // master.seek('scene03');
  }



  /*------------------------------------
  Tabs change
  -------------------------------------*/
  tabsChange() {
    let self = this,
      tabsId;


    this.tabs.on("click", event => {

      if(!$(event.currentTarget).hasClass('is-active')) {
        self.tabs.removeClass("is-active");
        self.tabsContent.removeClass("is-active");
        tabsId = $(event.currentTarget).data("tabs-id");

        $('[data-tabs-id="' + tabsId + '"]').addClass("is-active");

        self.smoothScrollFunc(self,event);
      }

      return false;
    });
  }

  kvPanelChange() {
    let tabsId,
      self = this;

    const margin = this.offsetY,
      time = this.time,
      hash = this.hash;

    this.$body.on("click", ".kv__panel a.js-kv-scroll", event => {
      self.tabs.removeClass("is-active");
      self.tabsContent.removeClass("is-active");
      tabsId = $(event.currentTarget).data("tabs-id");

      $('[data-tabs-id="' + tabsId + '"]').addClass("is-active");

      self.smoothScrollFunc(self,event);

      return false;
    });
  }


  /*------------------------------------
    smooth scroll Function
  -------------------------------------*/
  smoothScrollFunc(self, event) {
    let href = $(event.currentTarget).attr("href"),
        $target = $(href),
        pos = $target[0] && $target !== "#pagetop" ? $target.offset().top - self.offsetY : 0;

    $("html,body").animate({
      scrollTop: pos
    }, {
      duration: self.time,
      easing: 'swing'
    });

    $(this).blur();
  }


  /*------------------------------------
    smooth scroll
  -------------------------------------*/
  smoothScroll() {
    let self = this;

      this.$body.on("click", ".js-scroll", event => {
        self.smoothScrollFunc(self,event);

        return false;
      });
  }



  /*------------------------------------
  WATCH VIDEO
  -------------------------------------*/
  modalVideo() {
    var self = this,
    // $win = $(window),
    // $html = $('html'),
    // $body = $('body'),
    $videoContentOn,
    style,
    historyFlag = false,
    transitionFlag = false,
    scrollFlag = false,
    ACTIVE = 'is-active',
    DEVICE,$current,windowH,heightH,uniqueElem,current_scrollY,currentData;

    var ua = navigator.userAgent.toLowerCase(),
        isiPad = (ua.indexOf('ipad') > -1);

    var $videoContent = '<div class="modal" data-modal>\
                            <div data-modal-close class="modal-bg"></div>\
                                <div class="modal-inner">\
                                    <div id="player">\
                                        <video data-video-id \
                                        data-account="4631489730001" \
                                        data-player="BJKE2i5G" \
                                        data-embed="default" \
                                        data-application-id \
                                        class="video-js" \
                                        controls></video>\
                                        <script src="//players.brightcove.net/4631489730001/BJKE2i5G_default/index.min.js"></script>\
                                    <div data-modal-close class="modal-close"></div>\
                                </div>\
                            </div>\
                        </div>';


    //動画開く
    $('[data-modal-open]').on('click',function(e){
      e.preventDefault();

      var $this = $(this),
          POS = self.$win.scrollTop() + ( self.$win.height() / 2 ),
          videoUrl = $this.attr('href');

      $videoContentOn = $videoContent.replace('data-video-id', 'data-video-id="'+videoUrl+'"');

      self.$body.append($videoContentOn);
      $('[data-modal]').fadeIn();


      //動画を再生
      $('#player video').get(0).play();
      $('#player .video-js').addClass('vjs-has-started');

      current_scrollY = self.$win.scrollTop();
      style =  'top: '+ -current_scrollY +'px !important;';

      $('#body_inner').addClass('is-fixed');
      $('#body_inner').css({'cssText': style});
    });

    //動画閉じる
    $(document).on('click', '[data-modal-close]', function(){
        // $('#player video').get(0).pause();
        $('[data-modal]').fadeOut();

        $('#body_inner').removeClass('is-fixed');
        $('#body_inner').attr( { style: '' } );
        $('html, body').prop( { scrollTop: current_scrollY } );
        $('#player .video-js').removeClass('vjs-has-started');

        $('[data-modal]').remove();
    });

    return false;
  }
}